export const NEW_AVATAR_UPLOAD = "NEW_AVATAR_UPLOAD";
export const NEW_AVATAR_UPLOAD_SUCCESS = "NEW_AVATAR_UPLOAD_SUCCESS";
export const NEW_AVATAR_UPLOAD_FAIL = "NEW_AVATAR_UPLOAD_FAIL";
export const NEW_AVATAR_UPLOAD_RESET = "NEW_AVATAR_UPLOAD_RESET";
